import React from 'react';
import styles from './styles.scss';
export const Tooltip = _ref => {
  let {
    children,
    content
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.tooltip
  }, children, /*#__PURE__*/React.createElement("span", {
    className: styles.content,
    "aria-hidden": "true"
  }, content));
};
//# sourceMappingURL=tooltip.js.map